import 'core-js/stable';
import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
//import store from "./store/store";
import store from './store/index';
import VueFormWizard from 'vue-form-wizard';
import titleMixin from './mixins/titleMixin';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Multiselect from 'vue-multiselect';
import Loading from 'vue-loading-overlay'; //vue-loading-overlay (https://github.com/ankurk91/vue-loading-overlay)
//import vee-validate
import { ValidationProvider, ValidationObserver } from 'vee-validate';
//estilos de componentes
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-loading-overlay/dist/vue-loading.css'; //vue-loading-overlay (https://github.com/ankurk91/vue-loading-overlay)
//importacion de instancia personalizada de Axios
import axiosMailUpdate from './services/axiosApi';
Vue.prototype.$http = axiosMailUpdate;
import axiosInterceptors from './services/axiosInterceptors';
axiosInterceptors(store);
import VueProgressBar from 'vue-progressbar'; //vue-progressbar (https://github.com/hilongjw/vue-progressbar)
//plugins third party
require('./plugins/fontAwesome');
Vue.prototype.$appName = 'MailUpdate';
// componente global vue-multiselect
Vue.component('multiselect', Multiselect);
//mixins globales
Vue.mixin(titleMixin);
/* <----------- vue-progressbar -----------> */
Vue.use(VueProgressBar, {
	color: '#97CA3D',
	failedColor: 'red',
	height: '10px',
	thickness: '10px',
});
Vue.config.performance = true;
// bootstrap UI
Vue.use(BootstrapVue);
// plugin de iconos del componente UI de bootstrap
Vue.use(IconsPlugin);
// template coreUI para Vue
Vue.use(CoreuiVue);
// componente Vue-form-wizard para creacion de formularios con multiples pasos (https://binarcode.github.io/vue-form-wizard/#/)
Vue.use(VueFormWizard);
//componente vee-validate (https://logaretm.github.io/vee-validate/) para validaciones
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
//libreria momentjs para formateo de fechas
import moment from 'moment';
moment.locale('es-us');
Vue.prototype.$moment = moment;
/*componente para autocomplete (https://autocomplete.trevoreyre.com) */
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';

Vue.use(Autocomplete);

//idle vue
import IdleVue from 'idle-vue';
const eventsHub = new Vue();
Vue.use(IdleVue, {
	eventEmitter: eventsHub,
	store,
	idleTime: process.env.VUE_APP_EXPIRATION_TIMER,
	//idleTime: 10000,
	startAtIdle: false,
});
//vueFileAgent (https://github.com/safrazik/vue-file-agent)
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
Vue.use(VueFileAgent);
//componente vue-loading-overlay (https://github.com/ankurk91/vue-loading-overlay)
//Vue.component('loading-overlay', Loading)
Vue.use(Loading, {
	width: 128,
	height: 128,
	backgroundColor: '#ffffff',
	opacity: 0.5,
	zIndex: 999,
	color: '#FFF200',
	loader: 'bars',
});
//importacion para el modo de intercacion de vee-validate
import { setInteractionMode } from 'vee-validate';
setInteractionMode('eager');
import { localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
//activacion de idioma para vee-validate
localize('es', es);
//iconos
import { freeSet } from '@coreui/icons';
Vue.prototype.$log = console.log.bind(console);
Vue.config.productionTip = false;

// maska, componente para incluir mascaras (https://github.com/beholdr/maska)
import Maska from 'maska';
Vue.use(Maska);

new Vue({
	el: '#app',
	router,
	store,
	icons,
	template: '<App/>',
	components: {
		App,
	},
});
